<template>
    <div class="relative inline-flex">
        <button
            ref="trigger"
            class="inline-flex justify-center items-center group"
            aria-haspopup="true"
            @click.prevent="dropdownOpen = !dropdownOpen"
            :aria-expanded="dropdownOpen"
        >
            <img class="w-8 h-8 rounded-full" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" width="32" height="32" />

            <div  class="flex items-center truncate">
                <span class="truncate ml-2 text-sm font-medium text-sky group-hover:text-sky-400 hidden sm:block">{{ $page.props.user.name }}</span>
                <svg class="w-3 h-3 shrink-0 ml-1 fill-current text-gray-400" viewBox="0 0 12 12">
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"/>
                </svg>
            </div>
        </button>
        <transition
            enter-active-class="transition ease-out duration-200 transform"
            enter-from-class="opacity-0 -translate-y-2"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-out duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-show="dropdownOpen" class="origin-top-right z-10 absolute top-full min-w-44 bg-white border
                border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1" :class="align === 'right' ? 'right-0' : 'left-0'"
            >
                <div class="pt-0.5 pb-2 px-3 mb-1 border-b border-gray-200">
                    <div class="font-medium text-gray-800">{{ $page.props.user.name }}</div>
                    <div class="text-xs text-gray-500 italic capitalize">{{ $page.props.user.role }}</div>
                </div>
                <ul
                    ref="dropdown"
                    @focusin="dropdownOpen = true"
                    @focusout="dropdownOpen = false"
                >
                    <li>
                        <a :href="route(profileLink)"
                            class="font-medium text-sm text-sky-500 hover:text-sky-600 flex items-center py-1 px-3"
                            @click="dropdownOpen = false">Profile
                        </a>
                    </li>
                    <li>
                        <a href="#"
                            class="font-medium text-sm text-red-500 hover:text-red-600 flex items-center py-1 px-3"
                            @click="logout"> Déconnexion
                        </a>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
    import {ref, onMounted, onUnmounted} from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';
    import useDropdown from '@/composables/dropDown'

    export default {
        name: 'DropdownProfile',

        props: {
            align: String,
            profileLink: {
                type: String,
                default: 'profile.show'
            }
        },
        components: {
            Link
        },

        setup() {
            const { dropdownOpen, trigger, dropdown } = useDropdown()

            return {
                dropdownOpen,
                trigger,
                dropdown,
            }
        },

        methods: {
            logout() {
                this.dropdownOpen = false
                this.$inertia.post(route('logout'));
            },
        }
    }
</script>
